module.exports = __webpack_public_path__ + "text&logSdk.pdf";